var _path, _path2, _path3, _g, _path4, _path5, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2857 18.5715C24.2857 15.5753 21.7893 13.1428 18.7142 13.1428H7.57135C4.49645 13.1428 2 15.5753 2 18.5715C2 21.5675 4.49645 24 7.57135 24H18.7142C21.7893 24 24.2857 21.5675 24.2857 18.5715Z",
  fill: "#FFC531"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4291 4C17.6866 4 21.1433 7.45658 21.1433 11.7143C21.1433 15.972 17.6866 19.4286 13.4291 19.4286C9.17137 19.4286 5.71478 15.972 5.71478 11.7143C5.71478 7.45658 9.17137 4 13.4291 4Z",
  fill: "#FF9E00"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud-colored.svg__mask0_2082_17663",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 13,
  width: 11,
  height: 11
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.42953 13.1428C10.4257 13.1428 12.8582 15.5753 12.8582 18.5715C12.8582 21.5675 10.4257 24 7.42953 24C4.43348 24 2.00104 21.5675 2.00104 18.5715C2.00104 15.5753 4.43348 13.1428 7.42953 13.1428Z",
  fill: "#FFC531"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud-colored.svg__mask0_2082_17663)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.43 4.00002C17.6876 4.00002 21.1443 7.4566 21.1443 11.7143C21.1443 15.972 17.6876 19.4286 13.43 19.4286C9.17234 19.4286 5.71576 15.972 5.71576 11.7143C5.71576 7.4566 9.17234 4.00002 13.43 4.00002Z",
  fill: "#FFCF38"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.572 8.57142C22.8297 8.57142 26.2863 12.028 26.2863 16.2856C26.2863 20.5434 22.8297 24 18.572 24C14.3144 24 10.8578 20.5434 10.8578 16.2856C10.8578 12.028 14.3144 8.57142 18.572 8.57142Z",
  fill: "#FF6331"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud-colored.svg__mask1_2082_17663",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 8,
  width: 17,
  height: 16
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5723 8.5714C22.8301 8.5714 26.2867 12.028 26.2867 16.2856C26.2867 20.5433 22.8301 24 18.5723 24C14.3148 24 10.8581 20.5433 10.8581 16.2856C10.8581 12.028 14.3148 8.5714 18.5723 8.5714Z",
  fill: "#FF6331"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud-colored.svg__mask1_2082_17663)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4297 3.99999C17.6873 3.99999 21.144 7.45658 21.144 11.7143C21.144 15.972 17.6873 19.4286 13.4297 19.4286C9.17204 19.4286 5.71545 15.972 5.71545 11.7143C5.71545 7.45658 9.17204 3.99999 13.4297 3.99999Z",
  fill: "#FF6331"
}))));
export { SvgCloudColored as ReactComponent };